import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('agent_token') || '',
    agentInfo: JSON.parse(localStorage.getItem('agent_info') || 'null')
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentAgent: state => state.agentInfo,
    agentId: state => (state.agentInfo ? state.agentInfo.agent_id : 0),
    memberId: state => (state.agentInfo ? state.agentInfo.member_id : 0)
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('agent_token', token)
    },
    SET_AGENT_INFO(state, info) {
      state.agentInfo = info
      localStorage.setItem('agent_info', JSON.stringify(info))
    },
    LOGOUT(state) {
      state.token = ''
      state.agentInfo = null
      localStorage.removeItem('agent_token')
      localStorage.removeItem('agent_info')
    }
  },
  actions: {
    login({ commit }, { token, agentInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_AGENT_INFO', agentInfo)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
})
